const dates = {
  thisweek: []
};

export default function(state = dates, action) {
  switch (action.type) {
    case "Found This Week":
      return {
        ...state,
        thisweek: action.payload
      };
      break;
    default:
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/reducers/date-reducer.js